export const FloatClasses = `
<div>
  <div className="float-left">Float left on all viewport sizes</div>
  <br />
  <div className="float-right">Float right on all viewport sizes</div>
  <br />
  <div className="float-none">Don't float on all viewport sizes</div>
</div>
`

export const FloatResponsive = `
<div>
  <div className="float-sm-left">
    Float left on viewports sized SM (small) or wider
  </div>
  <br />
  <div className="float-md-left">
    Float left on viewports sized MD (medium) or wider
  </div>
  <br />
  <div className="float-lg-left">
    Float left on viewports sized LG (large) or wider
  </div>
  <br />
  <div className="float-xl-left">
    Float left on viewports sized XL (extra-large) or wider
  </div>
  <br />
</div>
`
